'use strict';
import angular from 'angular';
import './leads.constants';
import './base/leads.ctrls';
import './base/leads.components';
import './base/leads.services';
import './base/leads.resources';
import './notes/leads.notes.models';

angular.module('core.leads', [
    'core.leads.constants',
    'core.leads.ctrls',
    'core.leads.components',
    'core.leads.models',
    'core.leads.services',
    'core.leads.resources'
]);